var BraintreeOurPay = (function ($, _, CheckoutApiModel, braintree, CheckoutSettings) {

	var PaymentConditions = Backbone.Model.extend({
		defaults: {
			MinAmountThreshold: 0,
			MaxAmountThreshold: 0
		}
	});

	var PlannedTransaction = Backbone.Model;

	var PlannedTransactions = Backbone.Collection.extend({
		model: PlannedTransaction
	});

	var BillingAgreement = Backbone.Model.extend({
		initialize: function (attrs) {
			this.set('PlannedTransactions', new PlannedTransactions(attrs && attrs.PlannedTransactions || []));
		},

		update: function (attrs) {
			this.set(_.omit(attrs, 'PlannedTransactions'));
			this.get('PlannedTransactions').update(attrs && attrs.PlannedTransactions || []);
			this.trigger('update', this);
		}
	});

	var BraintreeOurPay = CheckoutApiModel.extend({
		defaults: {
			Amount: 0,
			PaymentSchemeDescription: '',
			LastPaymentMethod: ''
		},

		initialize: function (attrs, opts) {
			_.bindAll(this, '_update');
			this._onUpdateCheckout(this._update);

			this.listenTo(this._checkoutStoreDispatcher, 'ourpay-error', _.bind(this._onPayError, this));

			this.set('BillingAgreement', new BillingAgreement(attrs && attrs.BillingAgreement || {}));

			this.set('PaymentConditions', new PaymentConditions(attrs && attrs.PaymentConditions || {}));
		},

		_update: function (data) {
			var attrs = data.Value.MyPayDetails;

			this.set(_.extend({}, this.defaults, _.omit(attrs, 'BillingAgreement', 'PaymentConditions', 'LastPaymentMethod')));
			this.get('BillingAgreement').update(attrs && attrs.BillingAgreement || {});
			this.get('PaymentConditions').set(attrs && attrs.PaymentConditions || {});
			this.trigger('update');
		},

		ourpayMode: function () {
			return this.get('OurpayMode');
		},

		isAvailable: function () {
			return this.isEnabled() && !this.isRejected();
		},

		isEnabled: function () {
			return !this._isDisabledByAppSetting()
				&& !this._isDisabledByResponse()
				&& !this.isRejectedByUntrusted();
		},

		isRejected: function () {
			return !this.get('Enabled') && this.get('ReasonCode');
		},

		isRejectedByOutOfRange: function () {
			return this.get('ReasonCode') === CheckoutSettings.MyPayRejectionCodes.outOfRange;
		},

		isRejectedByExceededDebtLimit: function () {
			return this.get('ReasonCode') === CheckoutSettings.MyPayRejectionCodes.exceededDebtLimit;
		},

		isRejectedByUntrusted: function () {
			return this.get('ReasonCode') === CheckoutSettings.MyPayRejectionCodes.untrusted;
		},

		isRejectedByInvalidPaymentMethod: function () {
			var myPayWithPayPalEnabled = CheckoutSettings.getBasketSettings().MyPayWithPayPalEnabled;
			return this.get('ReasonCode') === CheckoutSettings.MyPayRejectionCodes.invalidPaymentMethod &&
				(!myPayWithPayPalEnabled || currentMethod.OrderPaymentType !== CheckoutSettings.OrderPaymentType.BrainTreePayPal);
		},

		_isDisabledByResponse: function () {
			return !this.get('Enabled') && !this.get('ReasonCode');
		},

		_isDisabledByAppSetting: function () {
			return !CheckoutSettings.getBasketSettings().MyPayEnabled;
		},

		_onPayError: function (data) {
			var rejectionCode = data.Value && data.Value.rejectionCode;

			rejectionCode &&
				this._update({
					Value:
					{
						MyPayDetails: {
							ReasonCode: rejectionCode,
							Enabled: false
						}
					}
				});
		}
	});

	return BraintreeOurPay;
})($, _, CheckoutApiModel, braintree, CheckoutSettings, PromiseUtil);
